import {FieldController} from "./elements.field.controller";
import {inputTextController} from "./elements.controllers.module"
import {Fias} from "./../../core/kladr";





class inputAddressController  extends FieldController  {
    static get $inject(){ return  ['$log', '$scope', '$element', 'FiasService'];}
    constructor($log, $scope, $element, FiasService){
        super($log, $scope, $element, FiasService);
        this._fields ={}; 
        this.fias = FiasService;
        this.fiasFields= [];
    }

    onSaveForm  (event, data){

 
        if(!this.notAllowEmpty){
            return
        }
   
        


        let error = false;

        for (const key in this._fields ) {
            if (Object.hasOwnProperty.call(this._fields , key)) {
                const element = this._fields[key];
                if(element  instanceof inputTextController){

                    let raiseError = false; 
                    let needleMini = [
                        'Area',
                        'City',
                        'Street',
                        'Index'
                    ] ;


                    switch(this.typeCheck){

                        case "mini":

                            if(needleMini.indexOf(element.fieldName.replace('model.', ''))>-1){
                                
                                continue;
                            }
                            
                            raiseError=!element.model
                            
                            break;
                        default:
                            raiseError=!element.model
                    }

                    if(raiseError){
                        error = true;
                        this.$scope.$broadcast('errorEvent',{
                            field: this._fields[key].fieldName,
                            message:'Необходимо заполнить поле',
                        })

                    }
                }
            }
        }


        if(error){
            data.haveError(this);
        }

    }

    $onInit() {
   
       super.$onInit();
       
       

       self.hideIndex = self.hideIndex || false; 

       if(this.defaultRegion && this.model){
        this.model.Region = this.defaultRegion ;
       }
    }


    onInitFields(event, data){
       
        switch(data.name){
     
            case "model.Area":
            case "model.City":
            case "model.Street":
            case "model.Region":
                this._fields[data.name.replace('model.','')] = data.field;
                break;

            case "model.Index":
                if(!this.hideIndex){
                    this._fields[data.name.replace('model.','')] = data.field;
                }
                
            
            break;

            default:
              
            break;
        }

    }

    $postLink(){
        super.$postLink();
        


        for (const key in Fias.type) {
            if (Object.hasOwnProperty.call(Fias.type, key)) {
                const element = Fias.type[key];
                
                const $el = $('[fias-'+element+']', this.$element);
                if($el.length){
                    const node ={
                        type: element, 
                        input: $el,
                        items: [],
                        showSpinner: false,
                        showWindow: false,
                        position:{
                            top:0, 
                            left:0,
                            width:0,
                            height:0,
                        }
                    };

                    $el.on('keyup', this.open.bind(this, node))
                    $el.on('keydown', this.keySelect.bind(this, node))
                    $el.on('blur',  ()=>{
                        

                        this.fiasFields.forEach(element => {
                            element.showWindow=false
                            element.showSpinner=false
                        });
                    })

                    this.fiasFields.push(node);

                }

            }
        }
        
     
       
        
      //  console.log('init fias ', this);
    }


    selectFiasVariant(field, option){
     

        field.showWindow= false;
        field.value = option.id; 
        field.option  = option 
        field.input.find('input').val(option.name+' '+ option.typeShort);
        field.input.find('input').trigger('change')

        if(!option.parents || !option.parents.length){
            return ;
        }

        if(option.zip){
            if( this.model.Address){
                this.model.Address.Index = option.zip
            }
            this.model.Index= option.zip
 
        }

 



    }

    closeFiasVariant(field){
        field.showWindow = false;
    }

    open(element, event){
        const val =element.input.find('input').val() ;
        if(!val){
            element.showWindow = false;
            return 
        }

        if ((event.which > 8) && (event.which < 46)) {
            return;
        }
        
      


        if(!element.showWindow ){
            element.showWindow = true;
            this.position(element)
        }

        this.fiasFields.filter((el)=>el!=element).forEach(element => {
            element.showWindow = false;
        });


        element.showSpinner = true;
        this.fias.find(val, element, this.fiasFields).then(
            (data)=>{
                    element.items = data
            }, 
            ()=>{
                element.showSpinner = false;   
        });
       
    }

    keySelect(){

    }
    position(element){
       
        var 
            inputOffset = element.input.find('input').offset(),
            inputOffsetTop = element.input.get(0).offsetTop,
            inputOffsetLeft = element.input.get(0).offsetLeft,
            inputWidth =element.input.width(),
            inputHeight = element.input.outerHeight();

            if (!inputOffsetTop) {
                return;
            }


            if(inputOffset){
              //  inputOffsetLeft = inputOffset.left;
                inputOffsetLeft+=element.input.find('input').get(0).offsetLeft
            }

            
            if ((  element.position.top == inputOffsetTop)
                && (element.position.left == inputOffsetLeft)
                && (element.position.width == inputWidth)
                && (element.position.height == inputHeight)) {
                return;
            }


            

            element.position.top = inputOffsetTop;
            element.position.left = inputOffsetLeft;
            element.position.width = inputWidth;
            element.position.height = inputHeight;
            
            element.positionAutocomplete = {
                top: ( inputOffsetTop - 1) + inputHeight + 'px',
                left: inputOffsetLeft,
                width:inputWidth,

            }

            let $spinner = $('.spinner[data-type="'+element.type+'"]', this.$element)

            if(!$spinner.length){
                return 
            }


            var spinnerWidth = $spinner.width(),
            spinnerHeight = $spinner.height();

            element.positionSpinner = {
                top: inputOffset.top + (inputHeight - spinnerHeight) / 2 - 1,
                left: inputOffset.left + inputWidth - spinnerWidth - 2
            };

      

    }
    getFiasNode(type){
        let node = this.fiasFields.find(el=>el.type==type);
        if(node){
            return node; 
        }

   
        node ={
            type: type,
            value:  '',
            input: null,
            items: [],
            showSpinner: false,
            showWindow: false,
            position:{
                top:0, 
                left:0,
                width:0,
                height:0,
            }
        };

        this.fiasFields.push(node);
        return this.fiasFields.find(el=>el.type==type)
    }
    removeFiasByType(type){
        
        this.fiasFields = this.fiasFields.filter(item => item.type !== type)
    }
}



class inputAddressVlInfoController extends inputAddressController  {
    static get $inject(){ return  ['$log', '$scope', '$element', 'BXReferenceService', 'FiasService'];}
    constructor($log, $scope, $element, BXReferenceService, FiasService){
        super($log, $scope, $element, FiasService);
        this.Region = "Московская область";
        
        //tags: true
        this.typeObjectOption = [];
        this.districts = [];
        this.reference = BXReferenceService;
        

        BXReferenceService 
            .loadReference('bid')
            .then((data)=>{
                
                let area = data.ENERGO_DISTRICTS.items.find((el)=>el.label==this.model.Address.Area);
                if(area){
                    this.model.Address.Area = area.value
                    
                }
                this.districts =data.ENERGO_DISTRICTS.items.map((el)=>{
                    return {
                        id: el.value,
                        text: el.label
                    };
                });
            })

    }
    $onInit() {
        super.$onInit();
        
        this.model.Address.Region= this.Region;

      
    }

}


class inputAddressEnergoController  extends inputAddressController  {
    static get $inject(){ return  ['$log', '$scope', '$element', 'BXReferenceService', 'FiasService'];}
    constructor($log, $scope, $element, BXReferenceService, FiasService){
        super($log, $scope, $element, FiasService);
        
        this.Region = "Московская область";
        this.__typeObject ='';
        
        //tags: true
        this.typeObjectOption = [];
        this.districts = [];
        this.reference = BXReferenceService;
        

        BXReferenceService 
            .loadReference('bid')
            .then((data)=>{
                
                let area = data.ENERGO_DISTRICTS.items.find((el)=>el.label==this.model.Address.Area);
                if(area){
                    this.Area = area.value
                 
                }
                this.districts =data.ENERGO_DISTRICTS.items.map((el)=>{
                    return {
                        id: el.value,
                        text: el.label,
                        kladr: el.kladr
                    };
                });

               
            })



     //   this.$scope.$on('errorEvent', this.onErrorEvent.bind(this));
   

    }

    $onInit() {
        super.$onInit();
        
        this.model.Address.Region= this.Region;

        if(this.model.haveKadastrLand == undefined){
            this.haveKadastrLand = true
        }

        if(this.model.haveKadastrObject == undefined){
            this.haveKadastrObject = true
        }

      
        this.__typeObject = this.model.ObjectTypeUUID;
        this.reference 
            .loadReference('typeconnobject')
            .then((data)=>{
                
                let options = [] ; 
                for (const item of data) {
                    options.push({
                        id: item.value,
                        text: item.label
                    });
                }
                if(this.model.ObjectTypeUUID=='other'){
                
                    options.push({
                        id:this.model.ObjectTypeUUID,
                        text:this.model.Name
                    })
                    
                  }
    
                  this.typeObjectOption = options;
                  super.redraw();

        })
                
        

    }

    $postLink(){
        
        super.$postLink();

        this.presetRegion();
        

    }

    presetRegion(){
    
        const node = this.getFiasNode('region');
        node.value = '5000000000000' ; 
      
    }

    get typeObject(){
        return this.__typeObject; 
    }

    set typeObject(value){
       // this.model.ObjectTypeUUID =value; 
        
    }

    onChangeName(id,text){
        this.__typeObject = id;
        if(id.indexOf('other')>-1){
            this.model.ObjectTypeUUID='other';
        }else{
            this.model.ObjectTypeUUID=id;
        }

        this.model.Name=text;
    }

    

    onErrorEvent(event, data){
       /* console.info('inputAddressEnergoController::onErrorEvent  -  '+data.field, {
            event:event, 
            data:data
        });
*/
        switch(data.field){
            case "CadastralNumber":
                this.haveCadastralError = true;
                this.errorCadastralMessage = data.message; 
                data.haveField = true;
            break;

            case "ReferenceNumber":
                this.haveKadastrObjectError = true;
                this.errorKadastrObjectMessage = data.message; 
                data.haveField = true;
              
            break;

        }
    }

    get CadastralNumber(){
        return this.model?this.model.CadastralNumber: '';
    }

    set CadastralNumber(value){
        this.model.CadastralNumber = value ; 
        this.haveCadastralError = false; 
    }

    get haveKadastrLand(){
        return this.model?this.model.haveKadastrLand: undefined;
    }
    set haveKadastrLand(value){
        this.model.haveKadastrLand = value; 
        this.haveCadastralError = false; 

        if(!value && !this.haveKadastrObject){
            this.haveKadastrObject = true;
        }

    }



    get ReferenceNumber(){
        return this.model?this.model.ReferenceNumber: '';
    }

    set ReferenceNumber(value){
        this.model.ReferenceNumber = value ; 
        this.haveKadastrObjectError = false; 

    }

    get haveKadastrObject(){
        return this.model?this.model.haveKadastrObject: undefined;
    }
    set haveKadastrObject(value){
        this.model.haveKadastrObject = value; 
        this.haveKadastrObjectError = false; 

        if(!value && !this.haveKadastrLand){
            this.haveKadastrLand = true;
        }

    }

    get Area(){
        return  this.model.Address.Area; 
    }

    set Area(value){
      
        
        const district  = this.districts.find((el)=>el.id==value)

        

        if(district && district.kladr){


            const node = this.getFiasNode('district');
            node.value = district.kladr; 

        }else{
            this.removeFiasByType('district');
        }

        this.model.Address.Area = value


      

    }
  

}

export {
    inputAddressController,
    inputAddressEnergoController,
    inputAddressVlInfoController
}
;




// WEBPACK FOOTER //
// ./src/components/elements/input.address.controller.js